import { PillColor } from 'components/uikit/buttons/pill/PillButton';

export enum CascadeControl {
  /** The level is rendered as a `PillButtonGroup`. */
  Pills = 'pills',

  /** The level is rendered as a `DropDownInput`, or a `MultiSelectDropDownInput` when `multiple`. */
  Dropdown = 'dropdown',
}

export type CascadeOption<TValue> = {
  value: TValue;
  title: string;
  disabled?: boolean;
  className?: string;
  testId?: string;
  color?: PillColor;

  /** The level revealed when this option is selected.*/
  next?: CascadeLevel<TValue>;
};

export type CascadeLeafOption<TValue> = Omit<CascadeOption<TValue>, 'next'> & {
  next?: never;
};

type CommonLevelProps = {
  /** Identifies the level in the resulting selection. */
  key: string;

  title?: string;
  className?: string;
  testId?: string;
};

export type CascadePillsLevel<TValue> = CommonLevelProps & {
  control: CascadeControl.Pills;
  options: CascadeOption<TValue>[];
  color?: PillColor;
  multiple?: false;
};

export type CascadeDropdownLevel<TValue> = CommonLevelProps & {
  control: CascadeControl.Dropdown;
  multiple?: false;
  options: CascadeOption<TValue>[];
  placeholder?: string;
  required?: boolean;
  enableSearch?: boolean;
};

export type CascadeMultiDropdownLevel<TValue> = CommonLevelProps & {
  control: CascadeControl.Dropdown;
  multiple: true;
  options: CascadeLeafOption<TValue>[];
  placeholder?: string;
  enableSearch?: boolean;
  allSelectedLabel?: string;
};

export type CascadeLevel<TValue> =
  | CascadePillsLevel<TValue>
  | CascadeDropdownLevel<TValue>
  | CascadeMultiDropdownLevel<TValue>;

export type CascadeSelection<TValue> = Record<
  string,
  TValue | TValue[] | undefined
>;
